(function() {

    // Factory for the Alpine component
    const factory = (config = {}) => ({

        /** Registry of checkbox nodes */
        nodes: {},

        /** Active selections (array so x-model works) */
        selected: [],

        /** Injected config maps */
        descendantMap: config.descendantMap || {},
        descendantKeyMap: config.descendantKeyMap || {},

        /**
         * capacityAvailable:
         * {
         *   "2": { name: "Trockenblut", available: 100, required: 0 },
         *   "4": { name: "Kapillarblut", available: 100, required: 0 }
         * }
         */
        capacityAvailable: JSON.parse(
            JSON.stringify(config.capacityAvailable || {})),

        /**
         * capacityRequired:
         * {
         *   638: { 4: 1.5 },
         *   180: { 2: 1.0 },
         *   ...
         * }
         */
        capacityRequired: config.capacityRequired || {},

        userInteracted: false,

        requiredSampleMaterial: null,

        initGlobal() {

            // console.log('%c[TestIdent] Alpine INIT', 'color:#22c55e;font-weight:bold');

            this.$watch('selectedCsv', value => {
                const input = document.getElementById(
                    'selected-test-idents-csv');
                if (!input) return;
                if (input.value !== value) {
                    input.value = value;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });

            // React to Livewire event after data was loaded
            // Listen for Livewire event "loaded-data"

            // window.addEventListener('loaded-data', () => {
            //     // Sync checkboxes based on selected[]
            //     this.syncSelectedToCheckboxes();
            //
            //     // Re-run full logic
            //     this.normalize();
            //     this.recomputeCapacities();
            //     this.updateMaterialBars();
            //     this.updateCapacityDisabledState();
            //     this.updateRequiredSampleMaterial();
            // });
        },

        get missingSelection() {
            return this.userInteracted && 0 === this.selected.length;
        },

        get selectedCsv() {
            return this.selected.join(',');
        },

        set selectedCsv(val) {
            this.selected = val
                ? val.split(',').map(v => v.trim()).filter(v => v !== '')
                : [];
        },

        /** Selection helpers */

        // syncSelectedToCheckboxes() {
        //
        //     // Sync from selected[] -> DOM checkbox states
        //     for (const key in this.nodes) {
        //
        //         const node = this.nodes[key];
        //         if (!node || node.preselected) continue;
        //
        //         const input = document.getElementById('selected-test-idents-csv');
        //         const val = input.value;
        //         const selectedTestIdentIds = val
        //             ? val.split(',').map(v => v.trim()).filter(v => v !== '')
        //             : [];
        //
        //         node.el.checked = selectedTestIdentIds.includes(String(key));
        //     }
        //
        //     console.log('[syncSelectedToCheckboxes] applied', this.selected);
        // },

        isSelected(key) {
            return this.selected.includes(String(key));
        },

        addSelected(key) {
            key = String(key);
            if (!this.isSelected(key)) this.selected.push(key);
        },

        removeSelected(key) {
            key = String(key);
            this.selected = this.selected.filter(v => v !== key);
        },

        /**
         * Register checkbox
         * NEW: fourth parameter `isPreselected`
         */
        register(key, el, descendants, isPreselected = false) {

            key = String(key);

            this.nodes[key] = {
                el,
                descendants: Array.isArray(descendants) ? descendants.map(
                    String) : [],
                preselected: !!isPreselected,
            };

            const wrapper = el.closest('.button-option');

            if (isPreselected) {
                // Preselected nodes stay fixed
                el.checked = true;
                el.disabled = true;
                if (wrapper) wrapper.classList.add('disabled', 'preselected');
                this.addSelected(key);

            } else if (el.checked) {
                this.addSelected(key);
            }

            this.normalize();
            this.recomputeCapacities();
            this.updateMaterialBars();
            this.updateCapacityDisabledState();
            this.updateRequiredSampleMaterial();
        },

        /**
         * Handle user interaction
         */
        toggle(key) {

            this.userInteracted = true;

            key = String(key);
            const node = this.nodes[key];
            if (!node) return;

            // Preselected nodes are fixed
            if (node.preselected) {
                node.el.checked = true;
                return;
            }

            if (node.el.checked) this.addSelected(key);
            else this.removeSelected(key);

            this.normalize();
            this.recomputeCapacities();
            this.updateMaterialBars();
            this.updateCapacityDisabledState();
            this.updateRequiredSampleMaterial();
        },

        /**
         * Graph-based normalization:
         * - Remove selected children if parent selected
         * - Reset disabled state
         * - Disable descendants
         * - Never remove or modify preselected items
         */
        normalize() {
            const snapshot = [...this.selected];

            // Step 1: remove child selections if a parent is selected
            for (const a of snapshot) {
                for (const b of snapshot) {
                    if (a === b) continue;

                    const bDesc = this.nodes[b]?.descendants || [];
                    if (bDesc.includes(a)) {
                        const nodeA = this.nodes[a];

                        if (nodeA && !nodeA.preselected) {
                            nodeA.el.checked = false;
                            nodeA.el.dispatchEvent(
                                new Event('input', {bubbles: true}));
                            nodeA.el.dispatchEvent(
                                new Event('change', {bubbles: true}));
                            this.removeSelected(a);
                        }
                    }
                }
            }

            // Step 2: reset all nodes
            Object.values(this.nodes).forEach(n => {
                if (n.preselected) return; // keep disabled
                this.setNodeDisabled(n, false);
            });

            // Step 3: disable descendants
            for (const parent of this.selected) {
                const desc = this.nodes[parent]?.descendants || [];
                for (const childId of desc) {
                    const child = this.nodes[childId];
                    if (!child || child.preselected) continue;

                    child.el.checked = false;
                    this.removeSelected(childId);
                    this.setNodeDisabled(child, true);
                }
            }
        },

        /** Disable / enable one node (input + wrapper styling) */
        setNodeDisabled(node, disabled) {

            // Preselected nodes always stay disabled and styled
            if (node.preselected) {
                node.el.disabled = true;
                const wrapper = node.el.closest('.button-option');
                if (wrapper) wrapper.classList.add('disabled', 'preselected');
                return;
            }

            node.el.disabled = disabled;

            const wrapper = node.el.closest('.button-option');
            if (wrapper) {
                wrapper.classList.toggle('disabled', disabled);
                wrapper.classList.toggle('selected', disabled);
            }
        },

        /** ----- MATERIAL CALCULATION ----- */

        recomputeCapacities() {
            // Reset all required values
            for (const id in this.capacityAvailable) {
                this.capacityAvailable[id].required = 0;
            }

            // Sum requirements for selected TestIdents
            for (const testId of this.selected) {
                const req = this.capacityRequired[testId] || {};
                for (const matId in req) {
                    const amount = parseFloat(req[matId]) || 0;
                    if (!this.capacityAvailable[matId]) continue;
                    this.capacityAvailable[matId].required += amount;
                }
            }

            // Clamp
            for (const id in this.capacityAvailable) {
                const cap = this.capacityAvailable[id];
                if (cap.required < 0) cap.required = 0;
                if (cap.available > 0 && cap.required > cap.available)
                    cap.required = cap.available;
            }
        },

        updateMaterialBars() {

            const container = document.querySelector('.sample-material-info');
            if (!container) return;

            container.querySelectorAll('[data-material-id]').forEach(row => {

                const materialId = row.getAttribute('data-material-id');
                const mat = this.capacityAvailable[materialId];
                if (!mat) return;

                const percent = mat.available > 0
                    ? Math.min((mat.required * 100) / mat.available, 100)
                    : 0;

                const bar = row.querySelector('.sample-bar-fill');
                if (bar) bar.style.width = percent + '%';

                row.querySelectorAll('[data-seg]').forEach(seg => {
                    const index = Number(seg.getAttribute('data-seg'));
                    seg.classList.toggle('text-white', index <= mat.required);
                    seg.classList.toggle('text-gray-500', index > mat.required);
                });
            });
        },

        isOptionAllowedByCapacity(key) {
            key = String(key);

            const req = this.capacityRequired[key];
            if (!req) return true;

            for (const matId in req) {
                const needed = parseFloat(req[matId]) || 0;
                const mat = this.capacityAvailable[matId];
                if (!mat) continue;

                const remaining = mat.available - mat.required;
                if (remaining < needed) return false;
            }

            return true;
        },

        updateCapacityDisabledState() {
            for (const key in this.nodes) {
                const node = this.nodes[key];

                // Preselected nodes always disabled & styled
                if (node.preselected) {
                    node.el.checked = true;
                    this.setNodeDisabled(node, true);
                    continue;
                }

                // Selected items must stay enabled
                if (this.isSelected(key)) {
                    this.setNodeDisabled(node, false);
                    continue;
                }

                // If already disabled by graph logic → do not override
                if (node.el.disabled) continue;

                const allowed = this.isOptionAllowedByCapacity(key);
                this.setNodeDisabled(node, !allowed);
            }
        },

        updateRequiredSampleMaterial() {

            // track which material IDs are needed
            const requiredMaterialIds = new Set();

            // accumulate from the selected test idents
            for (const testId of this.selected) {
                const reqCaps = this.capacityRequired[testId] || {};
                for (const matId in reqCaps) {
                    requiredMaterialIds.add(String(matId));
                }
            }

            this.requiredSampleMaterial = [...requiredMaterialIds].sort().join('');
        },

    });

    // Safe registration
    if (window.Alpine) {
        window.Alpine.data('testIdentSelectionGlobal', factory);
    } else {
        document.addEventListener('alpine:init', () => {
            window.Alpine.data('testIdentSelectionGlobal', factory);
        });
    }
})();
